import React from "react";
import { Button, Space, Typography } from "antd";
import { FaPlus, FaUsers, FaFileExport } from "react-icons/fa";
import { IoIosSearch } from "react-icons/io";
import { useCan } from "../../../utils/permissions";

const { Title } = Typography;

const UserHeader = ({ 
  searchData, 
  setSearchData, 
  handleSearchInput, 
  loading, 
  handleRefresh, 
  setIsCreateModalVisible,
  handleExportData
}) => {
  const can = useCan();
  const canCreate = can("user", "create");
  const canRead = can("user", "read");
  return (
    <div className="d-flex justify-content-between align-items-center mb-4">
      <Title level={2} style={{ margin: 0 }}>
        <FaUsers style={{ marginRight: '10px' }} />
        User Management
      </Title>
      <Space>
        <div className="position-relative">
          <input
            type="search"
            className="search-input form-control"
            placeholder="Search Users"
            value={searchData}
            onChange={handleSearchInput}
            disabled={!canRead}
          />
          <IoIosSearch className={`icon-cls ${searchData ? 'search-icon-hidden' : ''}`} />
        </div>
        <Button
          onClick={handleRefresh}
          loading={loading}
          style={{ marginRight: '8px' }}
          disabled={!canRead}
        >
          Refresh Data
        </Button>
        <Button
          onClick={handleExportData}
          style={{ marginRight: '8px' }}
        >
          <FaFileExport />
        </Button>
        <Button
          type="primary"
          icon={<FaPlus />}
          onClick={() => canCreate && setIsCreateModalVisible(true)}
          disabled={!canCreate}
          size="large"
        >
          Add New User
        </Button>
      </Space>
    </div>
  );
};

export default UserHeader;
